export default function Badge(theme) {
  return {
    MuiBadge: {
      styleOverrides: {
        badge: {
          borderRadius: theme.shape.borderRadius,
          fontWeight: 600,
          fontSize: '0.75rem',
        },
        colorPrimary: {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        },
        colorSecondary: {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.secondary.contrastText,
        },
        colorError: {
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
        },
      },
    },
  };
}

